import { entity } from "../../infra/api/rpc/api";
import { FrontDate } from "./frontDate";

export enum WorkLocation {
  WorkLocation_UnKnown = 0,
  WorkLocation_Remote = 1,
  WorkLocation_Attendance = 2,
  WorkLocation_Both = 3,
}

export enum WorkCommunication {
  WorkCommunication_Unknown = 0,
  WorkCommunication_Chat = 1,
  WorkCommunication_Mail = 2,
  WorkCommunication_Other = 3,
}

export enum WorkDetail {
  WorkDetail_Unknown = 0,
  WorkDetail_OnlyMtg = 1,
  WorkDetail_Mtg_ActualWorking = 2,
}

export function intervalString(from: entity.PastCaseProject.Interval): string {
  switch (from) {
    case entity.PastCaseProject.Interval.Interval_Week:
      return "週";
    case entity.PastCaseProject.Interval.Interval_Month:
      return "月";
  }
  return "";
}

export class PastCaseProject {
  public static from(from: entity.PastCaseProject): PastCaseProject {
    const createdAtDate: FrontDate = FrontDate.from(from.createdAt);
    const updatedAtDate: FrontDate = FrontDate.from(from.updatedAt);

    return new PastCaseProject(
      from.id,
      from.title,
      from.meetingNum,
      from.meetingInterval,
      from.meetingMinutes,
      from.workingHour,
      from.workingInterval,
      from.feePerMonth,
      from.workLocation,
      from.workCommunication,
      from.workDetail,
      from.achievementReward,
      createdAtDate,
      updatedAtDate
    );
  }

  constructor(
    public readonly id: string,
    public readonly title: string,
    public readonly meetingNum: number,
    public readonly meetingInterval: entity.PastCaseProject.Interval,
    public readonly meetingMinutes: number,
    public readonly workingHour: number,
    public readonly workingInterval: entity.PastCaseProject.Interval,
    public readonly feePerMonth: number,
    public readonly workLocation: WorkLocation,
    public readonly workCommunication: WorkCommunication,
    public readonly workDetail: WorkDetail,
    public readonly achievementReward: string,
    public readonly createdAt: FrontDate,
    public readonly updatedAt: FrontDate
  ) {}
}



// WEBPACK FOOTER //
// ./src/domain/model/past_case_project.ts